import { render } from "./Contact_index_en.vue?vue&type=template&id=15c4179c&scoped=true"
import script from "./Contact_index_en.vue?vue&type=script&lang=js"
export * from "./Contact_index_en.vue?vue&type=script&lang=js"

import "./Contact_index_en.vue?vue&type=style&index=0&id=15c4179c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-15c4179c"

export default script